<template>
    <div>
        <section class="widget widget-intro">
            <div class="group-top align-items-start align-items-lg-center">
                <breadcrumbs
                    :breadcrumbs="breadcrumbs"
                    :product-counts="productCount"
                ></breadcrumbs>

                <div class="d-flex align-items-center"
                     style="gap: 1rem;"
                >
                    <AppearanceSelect
                        :init-appearance="currentAppearance"
                        @update="changeAppearance"
                    ></AppearanceSelect>

                    <order-rules
                        :rules="orderRules"
                        :selected-rule.sync="orderRule"
                    ></order-rules>
                </div>
            </div>
        </section>

        <section class="region region-seo" style="display: none !important;" v-if="productCategory">
            <div class="region-seo-right">
                <h1 class="region-seo-title">{{ productCategory.name }}</h1>
                <p class="region-set-desc" v-html="productCategory.description"></p>
                <a class="region-seo-link"
                   :href="route('shop.checkout.show')"
                   :title="__('Kosárösszesítő a :page oldalról', { page: productCategory.name })">
                    {{ __('Kosárösszesítő a :page oldalról', {page: productCategory.name}) }}
                </a>
            </div>
        </section>

        <banner :banner="banner"></banner>

        <section
            v-if="description"
            class="region region-seo product-list-description pointer-onhover"
            style="display: flex; align-items: center; justify-content: center">
            <div class="region-seo-right">
                <div class="region-set-desc m-0" id="truncated-marketing-box" v-html="description">
                </div>
                <div class="marketing-box-full-content hidden" v-html="description">
                </div>
            </div>
        </section>

        <div class="list no-padding" id="product-list">
            <div class="w-full text-center mb-10">
                <button v-if="prevPage && prevPage > 0 && !loading"
                        @click="fetchPrev"
                >
                    {{ __('Előző megjelenítése') }}
                </button>

                <div v-if="prevPage && prevPage && loading" class="w-full">
                    <div class="flex items-center justify-center">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                             fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                            <path class="opacity-75" fill="#b2d630"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        {{ __('Betöltés...') }}
                    </div>
                </div>
            </div>

            <template v-for="(product, index) in products.slice(0, currentAppearance === 6 ? 12 : 8)">
                <product-item
                    :product="product"
                    :is-plus-size="isPlusSize"
                ></product-item>

                <product-item
                    v-if="showGiftCardProduct(index)"
                    :product="giftCard"
                    :is-plus-size="isPlusSize"
                ></product-item>
            </template>

            <div v-if="! productsIsEmpty && productListRecommendations.length > 0"
                 class="my-5"
                 style="width: 100%;"
            >
                <ProductListRecommendations
                    :product-list-recommendations="productListRecommendations"
                    :is-plus-size="isPlusSize"
                ></ProductListRecommendations>
            </div>

            <template v-for="(product, index) in products.slice(currentAppearance === 6 ? 12 : 8)">
                <product-item
                    :product="product"
                    :is-plus-size="isPlusSize"
                ></product-item>

                <product-item
                    v-if="showGiftCardProduct(index)"
                    :product="giftCard"
                    :is-plus-size="isPlusSize"
                ></product-item>
            </template>

            <div v-if="productsIsEmpty" class="uppercase">
                {{ __('Nem található a keresésnek megfelelő termék.') }}
            </div>

            <mugen-scroll
                :handler="fetchNext"
                :should-handle="links && links.next && !loading">
            </mugen-scroll>
            <div v-if="loading" class="w-full">
                <div class="flex items-center justify-center">
                    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                         fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                stroke-width="4"></circle>
                        <path class="opacity-75" fill="#b2d630"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ __('Betöltés...') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MugenScroll from 'vue-mugen-scroll'
import ProductItem from './partials/ProductItem';
import Filters from '../productCategory/Filters';
import Breadcrumbs from './partials/Breadcrumbs';
import OrderRules from './partials/OrderRules';
import ProductListRecommendations from './ProductListRecommendations';
import AppearanceSelect from './partials/AppearanceSelect'

export default {
    name: 'ProductList',
    components: {
        OrderRules,
        Breadcrumbs,
        Filters,
        ProductItem,
        MugenScroll,
        ProductListRecommendations,
        AppearanceSelect,
    },

    props: {
        productListUrl: {
            type: String,
            required: true
        },
        filters: {
            type: Object,
        },
        productCategory: {
            type: Object,
            required: false,
        },
        description: {
            type: String,
            required: true,
        },
        breadcrumbs: {
            type: Array,
            required: true
        },
        orderRules: {
            type: Array,
            required: true,
        },
        selectedOrderRule: {
            type: String,
            required: true,
        },
        defaultProducts: {
            type: Array,
            required: true,
        },
        banner: {
            type: Object,
            required: false,
        },
        isPlusSize: {
            type: Boolean,
            default: () => false,
        },
        giftCard: {
            type: Object,
            required: false,
        },
        productListRecommendations: {
            type: Array,
            required: false,
            default: () => [],
        },
    },

    data() {
        return {
            loading: true,
            products: this.defaultProducts,
            links: null,
            productCount: 0,
            orderRule: this.selectedOrderRule,
            colorsFilter: null,
            sizesFilter: null,
            propertiesFilter: null,
            priceFilter: null,
            showOnlySale: false,
            showOnlyNews: false,
            currentAppearance: 4,
            prevPage: null,
        }
    },

    created() {
        this.$on('filter-product-list', params => this.filterBy(params))
        this.$bus.$on('filter-product-list', params => this.filterBy(params))

        const hasSaleParam = this.hasUrlParam(window.location.href, 'sale');
        const hasNewParam = this.hasUrlParam(window.location.href, 'new');

        if (hasSaleParam) {
            this.showOnlySale = true;
        }

        if (hasNewParam) {
            this.showOnlyNews = true;
        }
    },

    mounted() {
        this.fetchNext(this.productListUrl, true)
    },

    computed: {
        productsIsEmpty() {
            return this.products.length <= 0 && !this.loading
        }
    },

    watch: {
        orderRule() {
            this.links = null
            this.prevPage = null
            this.products = []
            this.fetchNext(this.productListUrl.replace(/page=[\d*]/g, 'page=1'))
        }
    },

    methods: {
        async fetchPrev() {
            this.loading = true

            await this.fetchData(this.links.prev.replace(/page=[\d*]/g, 'page=' + this.prevPage), false)
        },

        async fetchNext(url, init = false) {
            this.loading = true

            if (this.links && this.links.next) {
                url = this.links.next
            }

            if (!url) {
                this.loading = false
                return
            }

            if (init) {
                this.prevPage = this.hasUrlParam(url, 'page') - 2
            } else {
                const page = this.hasUrlParam(url, 'page');
                url = url.split('?')[0];
                url = url + '?page=' + page;
            }

            await this.fetchData(url)
        },

        async fetchData(url, isNext = true) {
            try {
                let params = {
                    orderBy: this.orderRule,
                    colors: this.colorsFilter,
                    sizes: this.sizesFilter,
                    properties: this.propertiesFilter,
                    price: this.priceFilter,
                }

                const hasSaleParam = this.hasUrlParam(url, 'sale');
                const hasNewParam = this.hasUrlParam(url, 'new');

                if (this.showOnlySale && !hasSaleParam) {
                    params.sale = 1;
                }

                if (this.showOnlyNews && !hasNewParam) {
                    params.new = 1;
                }

                const response = await axios.get(url, {
                    params: params
                })

                let responseUrl = response.request.responseURL.replace('/api', '')
                responseUrl = responseUrl.replace('page=1', 'page=2')
                responseUrl = responseUrl.replaceAll('%5B0%5D', '[]')
                responseUrl = responseUrl.replaceAll('%5B1%5D', '[]')

                if (isNext) {
                    window.history.pushState(null, '', responseUrl);
                } else {
                    this.prevPage--
                }

                const fetchedProducts = window.location.search.includes('sizes')
                    ? response.data.data.filter(product => product.size.quantity > 0)
                    : response.data.data.filter(product => product.size.quantity > 0 || product.sizes.some(size => size.quantity > 0))

                this.products = isNext ? this.products.concat(fetchedProducts) : fetchedProducts.concat(this.products)

                let links = response.data.links

                if (this.links && ! isNext) {
                    links.next = this.links.next
                }

                this.links = links
                this.productCount = response.data.meta.total
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },

        filterBy(filters) {
            this.links = null
            this.prevPage = null
            this.products = []
            this.colorsFilter = _.map(filters.colors, 'id')
            this.sizesFilter = _.map(filters.sizes, 'name')
            this.propertiesFilter = _.map(filters.properties, 'id')
            this.priceFilter = filters.price
            this.fetchNext(this.productListUrl.replace(/page=[\d*]/g, 'page=1'))
        },

        showGiftCardProduct(index) {
            return this.giftCard && index !== 0
                && ((index % 35 === 0) || (this.productCount < 35 && this.productCount - 1 === index))
        },

        hasUrlParam(url, param) {
            return new URL(url).searchParams.get(param)
        },

        changeAppearance(appearance) {
            this.currentAppearance = appearance
        },
    },
}
</script>

<style lang="scss" scoped>

.mugen-scroll {
    grid-area: mugen;
    position: relative;
    height: calc(100% + 300px);
    width: 100%;
    top: -300px;
}
</style>
